<template>
  <a :href="link.url" :target="link.target">
    {{ link.link || link.title }}
    <i v-if="isExternal(link.url)" class="far fa-external-link-alt"></i>
  </a>
</template>
<script>
  export default {
    name: 'Link',
    props: {
      link: Object,
    },
    methods: {
      isExternal(url) {
        return url.includes('http') && !url.includes('seattle.gov')
      }
    }
  }
</script>

<style lang="scss">
  .fa-external-link-alt {
    margin-left: 5px;
  }
</style>
